import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import { getPublicUrl } from "../../../../helpers/helper_functions";
import { InfoImage } from "./SharedComponents";

import "./InfoBox.css";

const ReligionInfo = () => {
  return (
    <div className="info-box-wrapper left-box">
      <p className="info-text-title">Religion and Mercy</p>
      <div className="info-text-body" id="plantbasedpower">
        <p>
          {" "}
          Islam, Christianity, Judaism, Hinduism, and many other religions say
          that animals should be shown compassion and mercy. Thousands of years
          ago, killing and eating animals was only done out of necessity for
          survival, which is no longer the case -- no religion supports
          slaughter for entertainment and gluttony.
        </p>
        <p>
          As identified by the{" "}
          <a href="https://middleeastvegansociety.org/vegan-islam">
            Middle East Vegan Society,
          </a>{" "}
          many hadiths in Islam revolve around showing mercy and love to
          animals, as they are also God's creation. There are also no mentions
          in the Bible of Christ eating meat, and many followers of Christ
          practice{" "}
          <a href="https://en.wikipedia.org/wiki/Christian_vegetarianism">
            pescetarianism or vegetarianism.
          </a>{" "}
          -- even the Garden of Eden was fully vegan!
        </p>
        <p>
          Eastern religions, such as Buddhism, Hinduism, and Jainism promote{" "}
          <a href="https://www.britannica.com/topic/ahimsa">
            ahimsa, or non-violence,
          </a>{" "}
          towards all living beings and strongly advocate against consuming meat
          -- citing ethics, health, and spiritual reasons why the consumption of
          animal products should be avoided.
        </p>
      </div>
    </div>
  );
};

const ReligionImage = () => {
  return (
    <InfoImage
      className="info-box-image"
      $background_image={getPublicUrl("assets/Home/bahai.webp")}
      $background_image_details={"no-repeat 60% 50%"}
    ></InfoImage>
  );
};

export default {
  info: () => <ReligionInfo />,
  image: () => <ReligionImage />,
};
